import { EFiltersActionTypes } from '../../actions/filters';
import { IFilters } from '../../types/filters';
import { TReduxActions } from '../../types/redux';

export const defaultFiltersState: IFilters = {
  ratings: [],
  tags: [],
};

export function filtersReducer(state: IFilters = defaultFiltersState, action: TReduxActions) {
  switch (action.type) {
    case EFiltersActionTypes.SetRatingFilters: {
      const checkedRates = state.ratings.map(el => (el.checked ? el.reviewRate : null)).filter(Boolean);

      return {
        ...state,
        ratings: action.payload.map(el => ({ ...el, checked: checkedRates.includes(el.reviewRate) })),
      };
    }

    case EFiltersActionTypes.ToggleRatingFilter: {
      return {
        ...state,
        ratings: state.ratings.map(rating =>
          rating.reviewRate === action.payload ? { ...rating, checked: !rating.checked } : rating,
        ),
      };
    }

    case EFiltersActionTypes.SetTagFilters: {
      return {
        ...state,
        tags: action.payload,
      };
    }

    case EFiltersActionTypes.ToggleTagFilter: {
      return {
        ...state,
        tags: state.tags.map(tag =>
          tag.type === action.payload ? { ...tag, isSelected: !tag.isSelected } : { ...tag, isSelected: false },
        ),
      };
    }

    case EFiltersActionTypes.ClearFilters: {
      return {
        ...state,
        ratings: state.ratings.map(rating => ({ ...rating, checked: false })),
        tags: state.tags.map(tag => ({ ...tag, isSelected: false })),
      };
    }

    default:
      return state;
  }
}
